<script lang="ts">
      import HeadingNode from './nodes/HeadingNode.svelte'
      import ParagraphNode from './nodes/ParagraphNode.svelte'
      import TextNode from './nodes/TextNode.svelte'
      import LinkNode from "./nodes/LinkNode.svelte"
      import QuoteNode from './nodes/QuoteNode.svelte';
      import CtaNode from './nodes/CtaNode.svelte'
      import InlineBlockNode from './nodes/InlineBlockNode.svelte'
      import BlockNode from './nodes/BlockNode.svelte';
      import LinebreakNode from './nodes/LinebreakNode.svelte'

      const table = new Map()
      table.set('text', TextNode)
      table.set('heading', HeadingNode)
      table.set('paragraph', ParagraphNode)
      table.set('linebreak', LinebreakNode)
      table.set('link', LinkNode)
      table.set('autolink', LinkNode)
      table.set('quote', QuoteNode)
      table.set('cta', CtaNode)
      table.set('block', BlockNode)
      table.set('inlineBlock', InlineBlockNode)
      

      

      let { root, children = undefined } = $props()

      const Element = $state(table.get(root.type))
</script>

<!--{root.type}-->
{#if Element}
  <Element node={root}>
    {@render children?.()}
  </Element>
{:else}
      {@render children?.()}
{/if}


<style lang="postcss">
</style>
